import { hover } from '@testing-library/user-event/dist/hover'
import React from 'react'
import { FrameworkConfig } from '../../constants'

const Framework = (props) => {
    let country = props.countryCode
    return (
        <section id="framework" className='overflow-x-hidden'>
            <div className='md:flex md:items-center'>
                <div>
                    <div className="framework-header sm:px-8 md:px-8">
                        <div className="flex gap-2 justify-center items-center sm:justify-center">
                            <h1 className='text-primary text-6xl font-bold'>3+</h1>
                            <h1 className='text-base leading-5'><span className='text-primary font-semibold block'>Framework</span> { FrameworkConfig[country].title }</h1>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex justify-center items-center sm:px-8 md:px-0">
                        <p className='text-center max-w-[80%] sm:max-w-[50%] md:hidden'>{ FrameworkConfig[country].paragraph }</p>
                    </div>
                    <div className="Lato-font flex flex-wrap justify-center items-center px-8 md:px-0">
                        {
                            FrameworkConfig[country].framework.map((value, index) => (
                                <div className={`framework-${value.name}px-2 py-4 h-full flex items-center justify-center sm:h-[270px] sm:w-1/2 md:w-1/4`}>
                                    <div className='bg-white w-full h-[100%] shadow-md px-4 py-6 rounded-sm transition duration-500 ease-in-out hover:-translate-y-0.5 sm:h-[90%] sm:py-1'>
                                        <a href={ value.url } className='group cursor-pointer'>
                                            <div className="svg flex justify-center items-center">
                                                <img src={ require(`../../assets/icons/${value.icon}`) } alt={`${value.name} Icons`} className='w-[100px] h-[100px] selection:bg-teal-400 selection:text-white' />
                                            </div>
                                            <div className="w-full flex flex-col justify-center items-center">
                                                <div className="w-fit">
                                                    <h1 className={`framework-${value.name}-heading text-2xl text-center font-semibold selection:text-white md:text-xl`}>{ value.name }</h1>
                                                    <div className={`framework-${value.name}-hover w-full h-0.5 bg-${value.color} scale-0 transition duration-500 ease-in-out group-hover:scale-100`}></div>
                                                </div>
                                            </div>
                                        </a>
                                        <div className="px-2 md:px-0">
                                            <p className={`text-center font-medium leading-5 selection:text-white md:text-xs`}>{ value.text }</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Framework